var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup32X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9413 11.1018L9.83106 5.81041L4.93454 10.7094L4.4917 10.2663L9.75514 5.00024L17.8907 10.3043L23.2174 5.60786L23.6349 6.07623L17.9413 11.1018Z",
    fill: "#233A80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01145 15.0894C1.45519 15.0894 0.189941 13.8235 0.189941 12.2665C0.189941 10.7095 1.45519 9.4436 3.01145 9.4436C4.56771 9.4436 5.83296 10.7095 5.83296 12.2665C5.83296 13.8235 4.56771 15.0894 3.01145 15.0894ZM3.01145 10.0765C1.80946 10.0765 0.822567 11.0513 0.822567 12.2665C0.822567 13.4818 1.80946 14.4565 3.01145 14.4565C4.21344 14.4565 5.20033 13.4691 5.20033 12.2665C5.20033 11.0639 4.21344 10.0765 3.01145 10.0765Z",
    fill: "#233A80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9538 16.0262C16.3976 16.0262 15.1323 14.7603 15.1323 13.2033C15.1323 11.6462 16.3976 10.3804 17.9538 10.3804C19.5101 10.3804 20.7753 11.6462 20.7753 13.2033C20.7753 14.7603 19.5101 16.0262 17.9538 16.0262ZM17.9538 11.026C16.7518 11.026 15.7649 12.0133 15.7649 13.2159C15.7649 14.4185 16.7518 15.4059 17.9538 15.4059C19.1558 15.4059 20.1427 14.4185 20.1427 13.2159C20.1427 12.0133 19.1558 11.026 17.9538 11.026Z",
    fill: "#233A80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46409 5.64581C7.90783 5.64581 6.64258 4.37994 6.64258 2.82291C6.64258 1.26587 7.90783 0 9.46409 0C11.0203 0 12.2856 1.26587 12.2856 2.82291C12.2856 4.37994 11.0203 5.64581 9.46409 5.64581ZM9.46409 0.645592C8.2621 0.645592 7.2752 1.63297 7.2752 2.83556C7.2752 4.03814 8.2621 5.02554 9.46409 5.02554C10.6661 5.02554 11.653 4.0508 11.653 2.83556C11.653 1.62031 10.6661 0.645592 9.46409 0.645592Z",
    fill: "#233A80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6975 6.44344C23.1412 6.44344 21.876 5.17757 21.876 3.62053C21.876 2.0635 23.1412 0.797607 24.6975 0.797607C26.2537 0.797607 27.519 2.0635 27.519 3.62053C27.519 5.17757 26.2537 6.44344 24.6975 6.44344ZM24.6975 1.44322C23.4955 1.44322 22.5086 2.41794 22.5086 3.63318C22.5086 4.84843 23.4955 5.82315 24.6975 5.82315C25.8995 5.82315 26.8864 4.83577 26.8864 3.63318C26.8864 2.4306 25.8995 1.44322 24.6975 1.44322Z",
    fill: "#233A80"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19.3176H0V19.9506H28V19.3176Z",
    fill: "#233A80"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 10.5L0.5 11.5L1 14L3 15L4.5 14.5L5 13.5L5.5 11.5L5 10.5L3.5 10H2.5L1.5 10.5Z",
    fill: "#233A80"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0.5H8.5L7.5 1L7 3.5L8 5L9.5 5.5L11.5 4.5L12 3L11.5 1.5L10.5 0.5H9.5Z",
    fill: "#233A80"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 1L23.5 1.5L22.5 2.5V5L23.5 6H25L26 5.5L27 5V3.5V2.5L26 1.5L24.5 1Z",
    fill: "#233A80"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 11H18L17.5 10.5L16 11.5L15.5 14L17 15.5H18.5L19.5 15L20.5 13.5L20 12L19.5 11Z",
    fill: "#233A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup32X);
export default __webpack_public_path__ + "static/media/Group32x.014ce5826b442364dfbe981f150aca88.svg";
export { ForwardRef as ReactComponent };